import {
  FaShieldAlt,
  FaCamera,
  FaPalette,
} from 'react-icons/fa';

const servicesData = [
  {
    category: 'Cyber Services',
    icon: FaShieldAlt,
    description: 'Internet, computer, IT support, and government services',
    // For Home.js compatibility - flat list
    items: [
      'Bulk Printing – From KSh 5',
      'Color Printing – From KSh 10',
      'High-Speed Scanning – JPG & PDF formats',
      'PDF Organization & Formatting',
      'Lamination – Cold & Warm',
      'Binding – Spiral & Tape',
      'Professional Passport Photos – Ready in 5 minutes',
      'E-Government & Online Portal Support',
      'Job Application Packages & Revamped CVs',
      'Revision Materials – KASNEB, KJSEA, KPSEA & Projects',
      'CBC Stationery & Supplies',
      'Excel Data Entry & Word Document Formatting',
      'Computer Training & Hands-on Experience',
      'HELB applications',
      'KUCCPS applications',
      'Phone Repair & Hardware Troubleshooting',
      'Software installation',
      'Phone flashing',
      'Phone unlocking',
      'Computer formatting',
      'Virus removal',
      'Data recovery',
      'Computer troubleshooting',
      'PDF conversion (Word ↔ PDF)',
      'Online form filling',
      'Visa application assistance',
      'Scholarship applications',
      'eCitizen applications',
      'KRA PIN registration',
      'KRA tax returns (iTax)',
      'Online research',
      'File downloads/uploads',
      'Social media accounts management',
    ],
    // For Services.js with collapsible structure
    subcategories: [
      {
        name: 'Printing, Scanning & Document Prep',
        items: [
          'Bulk Printing – From KSh 5',
          'Color Printing – From KSh 10',
          'High-Speed Scanning – JPG & PDF formats',
          'PDF Organization & Formatting',
          'Lamination – Cold & Warm',
          'Binding – Spiral & Tape',
          'Professional Passport Photos – Ready in 5 minutes',
        ],
      },
      {
        name: 'E-Government & Online Support',
        items: [
          'E-Government & Online Portal Support',
          'Job Application Packages & Revamped CVs',
          'eCitizen applications',
          'KRA PIN registration',
          'KRA tax returns (iTax)',
        ],
      },
      {
        name: 'Educational & CBC Materials',
        items: [
          'Revision Materials – KASNEB, KJSEA, KPSEA & Projects',
          'CBC Stationery & Supplies',
          'HELB applications',
          'KUCCPS applications',
          'University and college admissions',
          'School portal access',
          'Assignment typing',
          'Exam registration',
          'Certificate printing',
        ],
      },
      {
        name: 'Digital & Office Solutions',
        items: [
          'Excel Data Entry & Word Document Formatting',
          'Computer Training & Hands-on Experience',
          'PDF conversion (Word ↔ PDF)',
          'Online form filling',
          'Visa application assistance',
          'Scholarship applications',
          'Typesetting',
          'Document editing and formatting',
          'CV and cover letter writing',
          'File storage on flash drives or cloud',
        ],
      },
      {
        name: 'Tech & Hardware Repairs',
        items: [
          'Phone Repair & Hardware Troubleshooting',
          'Software installation',
          'Phone flashing',
          'Phone unlocking',
          'Computer formatting',
          'Virus removal',
          'Data recovery',
          'Computer troubleshooting',
          'Online research',
          'File downloads/uploads',
          'Social media accounts management',
        ],
      },
    ],
  },
  {
    category: 'Design',
    icon: FaPalette,
    description: 'Graphic design, branding, and creative services',
    items: [
      'Logo design',
      'Posters',
      'Flyers',
      'Banners',
      'Business cards',
      'Wedding cards',
      'Funeral programmes',
      'Certificates',
      'Calendars',
      'Social media posters',
      'Company profile design',
      'Branding materials',
      'Brand identity design',
      'Business name registration',
      'Company registration',
      'Business permit applications',
      'Invoice and receipt printing',
      'Bulk printing',
      'Exam and project printing',
      'Stationery sales (pens, papers, envelopes, files, etc.)',
    ],
    subcategories: [
      {
        name: 'Graphic Design & Marketing',
        items: [
          'Logo design',
          'Posters',
          'Flyers',
          'Banners',
          'Business cards',
          'Wedding cards',
          'Funeral programmes',
          'Certificates',
          'Calendars',
          'Social media posters',
        ],
      },
      {
        name: 'Branding & Identity',
        items: [
          'Company profile design',
          'Branding materials',
          'Brand identity design',
        ],
      },
      {
        name: 'Business & Document Services',
        items: [
          'Business name registration',
          'Company registration',
          'Business permit applications',
          'Invoice and receipt printing',
          'Bulk printing',
          'Exam and project printing',
          'Stationery sales (pens, papers, envelopes, files, etc.)',
        ],
      },
    ],
  },
  {
    category: 'Photography',
    icon: FaCamera,
    description: 'Photography services and photo printing',
    items: [
      'Passport-size photography',
      'Passport photo printing',
      'ID photo capture',
      'Professional headshots',
      'Event photography',
      'Product photography',
      'Document translation',
      'Secretarial services',
      'Bulk printing',
      'Exam and project printing',
      'Certificate printing',
      'File storage on flash drives or cloud',
    ],
    subcategories: [
      {
        name: 'Photography Services',
        items: [
          'Passport-size photography',
          'Passport photo printing',
          'ID photo capture',
          'Professional headshots',
          'Event photography',
          'Product photography',
        ],
      },
      {
        name: 'Document & Printing Services',
        items: [
          'Document translation',
          'Secretarial services',
          'Bulk printing',
          'Exam and project printing',
          'Certificate printing',
          'File storage on flash drives or cloud',
        ],
      },
    ],
  },
];

export default servicesData;